// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import BackgroundColorController from "./background_color_controller";
application.register("background-color", BackgroundColorController);

import ColorPickerController from "./color_picker_controller";
application.register("color-picker", ColorPickerController);

import CustomController from "./custom_controller";
application.register("custom", CustomController);

import FlashController from "./flash_controller";
application.register("flash", FlashController);

import ImageController from "./image_controller";
application.register("image", ImageController);

import KnobController from "./knob_controller";
application.register("knob", KnobController);

import LinkInterceptorController from "./link_interceptor_controller";
application.register("link-interceptor", LinkInterceptorController);

import ModalController from "./modal_controller";
application.register("modal", ModalController);

import PricingController from "./pricing_controller";
application.register("pricing", PricingController);

import SaveOnSelectController from "./save_on_select_controller";
application.register("save-on-select", SaveOnSelectController);

import SelectionController from "./selection_controller";
application.register("selection", SelectionController);

import SortableController from "./sortable_controller";
application.register("sortable", SortableController);

import StripeController from "./stripe_controller";
application.register("stripe", StripeController);

import ToggleController from "./toggle_controller";
application.register("toggle", ToggleController);

import { Dropdown } from "tailwindcss-stimulus-components";
application.register("dropdown", Dropdown);
